import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import {
  RANK_TAB_TYPE,
  TIME_TAB_CHANGE_TYPE,
  INDEX_RANK_ITEM_LIST_TYPE,
} from '.'
import { worksTimeTabsData } from './useWorks'

import { GET_ART_COLLECTION_LIST } from '~/graphqls/gqls'

import {
  getArtCollectionList,
  getArtCollectionListVariables,
  ArtworkCommonSortType,
  getArtCollectionList_marketingModule_artworkSeriesSort_edges_node,
} from '~/graphqls/types'

import { getGraphData } from '~/utils'

/** 合集榜tab分类 */
export const collectionTabList = [
  { key: ArtworkCommonSortType.TRADE_MONEY, name: '交易榜' },
  { key: ArtworkCommonSortType.LIKE_COUNT, name: '喜爱榜' },
  { key: ArtworkCommonSortType.COLLECT_COUNT, name: '收藏榜' },
]

export const useCollections = () => {
  const getCollectionList = useImperativeQuery<
    getArtCollectionList,
    getArtCollectionListVariables
  >(GET_ART_COLLECTION_LIST)

  /** 单tab数据切换 */
  const fetchSingle = async (params: getArtCollectionListVariables) => {
    let res: any = {}
    res = await getCollectionList(params)
    return getGraphData<getArtCollectionList_marketingModule_artworkSeriesSort_edges_node>(
      res.data?.marketingModule?.artworkSeriesSort?.edges || []
    )
  }

  /** 获取所有数据 */
  const fetchAll = async (params: getArtCollectionListVariables) => {
    const list = await Promise.all([
      getCollectionList({
        ...params,
        sortType: ArtworkCommonSortType.TRADE_MONEY,
      }),
      getCollectionList({
        ...params,
        sortType: ArtworkCommonSortType.LIKE_COUNT,
      }),
      getCollectionList({
        ...params,
        sortType: ArtworkCommonSortType.COLLECT_COUNT,
      }),
    ])

    return list?.map((res: any, index: number) => {
      return {
        type: collectionTabList[index].key,
        name: collectionTabList[index].name,
        data: getGraphData<getArtCollectionList_marketingModule_artworkSeriesSort_edges_node>(
          res.data?.marketingModule?.artworkSeriesSort?.edges || []
        ),
      }
    })
  }
  /** 首页数据卡片样式 */
  const formatIndexList = (
    list: getArtCollectionList_marketingModule_artworkSeriesSort_edges_node[],
    type: string,
    name: string,
    onTimeChange?: TIME_TAB_CHANGE_TYPE
  ): INDEX_RANK_ITEM_LIST_TYPE<getArtCollectionList_marketingModule_artworkSeriesSort_edges_node> => {
    return {
      parentType: RANK_TAB_TYPE.COLLECTIONS,
      type,
      name,
      data: list,
      timeTabsList: worksTimeTabsData,
      onTimeChange,
    }
  }

  /** 处理首页的展示逻辑 */
  const handleIndexAll = async (
    params: getArtCollectionListVariables,
    onTimeChange?: TIME_TAB_CHANGE_TYPE
  ) => {
    const allList = await fetchAll(params)
    return allList?.map(single => {
      return formatIndexList(
        single.data,
        single.type,
        single.name,
        onTimeChange
      )
    })
  }

  return {
    /** 合集榜 */
    getCollectionList,

    // 数据操作
    fetchCollectionsingle: fetchSingle,
    fetchCollectionsAll: fetchAll,
    formatCollectionsIndexList: formatIndexList,
    handleCollectionsIndexAll: handleIndexAll,
  }
}
